module.exports = __webpack_public_path__ + "img/016-boy-7.dd710e88.svg";